/** Resposta 409 do início quando a audiência passa do limite de mensagens do portfólio (conexão direta com a Meta). */
export function overLimitInfo(error: unknown): { message: string; limit: number; audience: number } | null {
  const r = (error as { response?: { status?: number; data?: { code?: string; message?: string; limit?: number; audience?: number } } })?.response;
  if (r?.status !== 409 || r.data?.code !== 'over_limit') return null;
  return { message: r.data.message || 'A audiência passa do limite de mensagens do portfólio.', limit: r.data.limit ?? 0, audience: r.data.audience ?? 0 };
}
